import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';

import {
  FunifierPlayerProvider,
  FunifierProviderRoutes,
  Providers,
} from '../../types/auth/AuthState';

const COURSE_ROUTE_PREFIX = 'assban_cursos';

function isCertificationRoute(route: FunifierProviderRoutes): boolean {
  return route.staging !== true && !route._id.startsWith(COURSE_ROUTE_PREFIX);
}

export function toCertificationProviders(
  routes: FunifierProviderRoutes[],
): Providers[] {
  return routes.filter(isCertificationRoute).map(route => ({
    value: route._id,
    label: route.name,
    openId: route.openId,
  }));
}

export function resolvePlayerRoutesResponse(result: {
  data?: unknown;
  error?: unknown;
}): { data: Providers[] } | { error: FetchBaseQueryError } {
  const data = result.data as Partial<FunifierPlayerProvider> | undefined;

  if (!data) {
    return { error: result.error as FetchBaseQueryError };
  }

  const routes = Array.isArray(data.routes) ? data.routes : [];

  return { data: toCertificationProviders(routes) };
}
